import React from 'react';
import useAuthContext from '../../contexts/AuthContext';
import SimpleResourceLandingLayout from '../../components/layouts/SimpleResourceLandingLayout';
import useColumns from './columns';

const ReclamationTable = () => {
  const { user } = useAuthContext();
  const columns = useColumns();

  return (
    <div>
      <SimpleResourceLandingLayout
        resourceName="reclamations"
        populate="contratId,insurer"
        extraQuery={`&customer=${user?._id}`}
        columns={[...columns]}
        customActionColumn
        onDoubleClickAction={false}
        withCreateButton={false}
        withUploadButton={false}
      />
    </div>
  );
};

export default ReclamationTable;
